/**
 * 定义 designer-editor 划重点素材的数据结构，供素材面板、上传弹窗与状态库共享
 */

/** 划重点素材的绘制模式 */
export type TextMarkKind = 'stretch' | 'cover' | 'use' | 'repeat' | 'combined';

/** 划重点 SVG 允许参与路径处理的节点类型 */
export const TextMarkSvgSupportPath = ['line', 'path', 'rect', 'use', 'circle', 'ellipse'];

/** 划重点素材的渲染配置 */
export interface TextMarkConfig {
    type: TextMarkKind;
    sizeRange: number[];
    enableSize: boolean;
    enableOpacity: boolean;
    src: string;
    defaultColor: string;
    defaultFontSize: number;
    position: 'top' | 'bottom' | 'center';
    repeatPath?: string;
    forceStretch?: boolean;
    offset: { x: number; y: number };
    padding: { x: number; y: number };
}

/** designer-editor 划重点素材记录 */
export interface TextMarkStruct {
    materialId: string;
    isVip?: boolean;
    data: TextMarkConfig;
    animate?: number;
    useBlackText?: number;
    thumbnail?: { width?: number; height?: number; url?: string };
    thumbnailBlack?: { width?: number; height?: number; url?: string };
}
